<template>
  <v-app>
    <v-toolbar
      fixed
      dense
      v-if='this.$route.name !== "Auth" && this.$route.name !== "Register"'
      color="#2c485b"
      app
    >
      <v-toolbar-title class="white--text">CommunityClick</v-toolbar-title>
      <!--<v-btn v-if="this.getUser().is_superuser !== null && this.getUser().is_superuser" flat dark @click="meeting">Meetings</v-btn>-->
      <v-btn flat dark @click="meeting">Meetings</v-btn>
      <v-spacer></v-spacer>

      <v-btn flat dark @click="logout">Logout</v-btn>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable */

  export default {
    name: 'App',

    methods: {
      meeting () {
        this.$router.push('/')
      },
      logout () {
        this.$session.destroy()
        this.$router.push('/auth')
      }
    }
  }
</script>

<style>
  body {
    overflow-y: hidden;
  }
</style>





// WEBPACK FOOTER //
// src/App.vue